import { Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import HeadingCard from "../../../newComponent/NewCardsComp/HeadingCard";
import FilterButtonComponent from "../../../newComponent/NewButtonComp/FilterButtonComponent";
import RecycleDetailedReport from "./RecycleDetailedReport";
import RecycleUserWiseReport from "./RecycleUserWiseReport";
import RecycleCampaignWise from "./RecycleCampaignWise";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function RecycleReport() {
  const [selectedCriteria, setSelectedCriteria] = useState("detailedreport");
  const [open, setOpen] = useState(false);
  const [isDownloadAccess, setIsDownloadAccess] = useState(false);
  const userId=localStorage.getItem("userId")

  useEffect(() => {
    if (
      selectedCriteria === "userwisereport" ||
      selectedCriteria === "eventwisereport" ||
      selectedCriteria === "eventattendees"
    ) {
      setOpen(true);
    }
  }, [selectedCriteria]);

  const handleChipClick = (criteria) => {
    setSelectedCriteria(criteria);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

    // Download Access
    useEffect(() => {
      fetch(`${API_ENDPOINT}route/downloadaccess/${userId}`)
        .then((response) => {
          if (response.ok) {
            setIsDownloadAccess(true);
          } else {
            setIsDownloadAccess(false);
          }
        })
        .catch((err) => {
          setIsDownloadAccess(false);
        });
    }, [userId]);
  return (
    <Grid container spacing={2}>
      {/* Heading */}
      <Grid item xs={12} lg={3.5} md={5} sm={6}>
        <HeadingCard label="Recycle Enquiry Report" />
      </Grid>

      {/* Added 3 button and filter */}
      <Grid item xs={12} md={12} sm={12} lg={12}>
        <Grid container>
          <Grid item xs={12} md={8} sm={12} lg={8}>
            <Grid container gap={2}>
              <Button
                size="small"
                style={{
                  fontWeight: selectedCriteria === "detailedreport" ? 600 : 500,
                  background:
                    selectedCriteria === "detailedreport" ? "#07b344" : "",
                  borderRadius: "10px",
                  color:
                    selectedCriteria !== "detailedreport" ? "#364152" : "white",
                  border:
                    selectedCriteria !== "detailedreport"
                      ? "0.5px solid #b2b2b4"
                      : "",
                }}
                onClick={() => handleChipClick("detailedreport")}
              >
                Detailed Report
              </Button>

              <Button
                size="small"
                style={{
                  fontWeight: selectedCriteria === "userwisereport" ? 600 : 500,
                  background:
                    selectedCriteria === "userwisereport" ? "#07b344" : "",
                  borderRadius: "10px",
                  color:
                    selectedCriteria !== "userwisereport" ? "#364152" : "white",
                  border:
                    selectedCriteria !== "userwisereport"
                      ? "0.5px solid #b2b2b4"
                      : "",
                }}
                onClick={() => handleChipClick("userwisereport")}
              >
                User Wise Specific Report
              </Button>

              <Button
                size="small"
                style={{
                  fontWeight:
                    selectedCriteria === "eventwisereport" ? 600 : 500,
                  background:
                    selectedCriteria === "eventwisereport" ? "#07b344" : "",
                  borderRadius: "10px",
                  color:
                    selectedCriteria !== "eventwisereport"
                      ? "#364152"
                      : "white",
                  border:
                    selectedCriteria !== "eventwisereport"
                      ? "0.5px solid #b2b2b4"
                      : "",
                }}
                onClick={() => handleChipClick("eventwisereport")}
              >
                Campaign Wise Specific Report
              </Button>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            md={4}
            sm={12}
            lg={4}
            display="flex"
            justifyContent="flex-end"
          >
            <FilterButtonComponent
              onClick={handleToggle}
              text="Filter"
              open={open}
              showendIcon={true}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        {/* showing component accoeding to criteria */}
        {selectedCriteria === "detailedreport" && (
          <RecycleDetailedReport open={open} isDownloadAccess={isDownloadAccess}/>
        )}
        {selectedCriteria === "userwisereport" && (
          <RecycleUserWiseReport open={open} isDownloadAccess={isDownloadAccess}/>
        )}
        {selectedCriteria === "eventwisereport" && (
          <RecycleCampaignWise open={open} isDownloadAccess={isDownloadAccess}/>
        )}
      </Grid>
    </Grid>
  );
}
